import type { TFunction } from 'i18next';
import { formatDateOnly } from '~/utils';

export function shipWeekLabel(
  t: TFunction<'inventory'>,
  expectedShipDate: string
): string {
  return t('inventory.buy_list.ship_week_value', {
    date: formatDateOnly(expectedShipDate),
  });
}
